// HydroWata kit JS — shared behaviours of the hw-* sections (ported from the approved mockup, 11/10/2026).
// Each init is idempotent (data-hw-on flag) and re-runs on `shopify:section:load` so the theme editor keeps working.
// Section-specific logic (buy box, gallery, cart drawer, blog) lives in that section's own JS.
window.HW = window.HW || {};
(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (el.getAttribute('data-hw-' + k)) return false; el.setAttribute('data-hw-' + k, '1'); return true; };

  // marquees / review rails: duplicate the track once so the CSS animation loops seamlessly
  function marquees(root) {
    $$('[data-mq] .mq__track, [data-vw] .vw__track', root).forEach(function (t) {
      if (!once(t, 'mq')) return;
      Array.prototype.slice.call(t.children).forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = -1; }); t.appendChild(k); });
    });
  }

  // "Why HydroWata" tabs: list buttons swap the pane, image and pill
  function whyTabs(root) {
    $$('[data-why]', root).forEach(function (w) {
      if (!once(w, 'why')) return;
      var items = $$('.why__item', w), panes = $$('.why__pane', w), img = w.querySelector('[data-why-img]'), pill = w.querySelector('[data-why-pill]');
      items.forEach(function (b, i) {
        b.addEventListener('click', function () {
          items.forEach(function (x, k) { x.classList.toggle('on', k === i); x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
          panes.forEach(function (p, k) { p.hidden = k !== i; });
          if (img && b.dataset.img) { img.src = b.dataset.img; img.alt = b.dataset.alt || ''; if (b.dataset.srcset) img.srcset = b.dataset.srcset; }
          if (pill && b.dataset.pill) pill.textContent = b.dataset.pill;
        });
      });
    });
  }

  // review video tiles: tap to play one, pause the others
  function videoTiles(root) {
    $$('[data-vt]', root).forEach(function (c) {
      if (!once(c, 'vt')) return;
      var v = c.querySelector('video'), b = c.querySelector('button');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        $$('[data-vt] video').forEach(function (o) { if (o !== v) o.pause(); });
        if (v.paused) { v.muted = false; v.play(); c.classList.add('playing'); } else { v.pause(); c.classList.remove('playing'); }
      });
    });
  }

  // click-to-play YouTube (About warehouse video): the iframe loads only on click
  document.addEventListener('click', function (e) {
    var v = e.target.closest && e.target.closest('[data-yt]'); if (!v || v.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + v.getAttribute('data-yt') + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = v.getAttribute('data-yt-title') || 'Video';
    v.appendChild(f); $$('.uvid__play,.uvid__cap', v).forEach(function (x) { x.remove(); });
  });

  // light sections alternate #f7faff / #eef8ff in page order (owner: neighbours never share a background).
  // Dark bands keep their slot. Runs over every hw section on the page.
  var SKIP = /(^|\s)(hero|closer|pd-strip|pg-trust)(\s|$)/;
  function alternate() {
    var secs = $$('main .hw section').filter(function (x) { return !x.parentElement.closest('.hw section') && x.offsetParent && !SKIP.test(x.className); });
    var k = 0, pend = [];
    secs.forEach(function (x, i) {
      if (/(^|\s)pd-top(\s|$)/.test(x.className) || (i === 0 && /pg-hero|sci-hero/.test(x.className))) { x.setAttribute('data-alt', '0'); k = 1; return; }
      if (/(^|\s)pg-head(\s|$)/.test(x.className)) { pend.push(x); return; }
      var a = String(k % 2); x.setAttribute('data-alt', a); pend.forEach(function (p) { p.setAttribute('data-alt', a); }); pend = []; k++;
    });
  }

  // shop grid filter tabs
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sc-tabs] button'); if (!b) return;
    var f = b.getAttribute('data-f'), wrap = b.closest('.hw') || document;
    $$('[data-sc-tabs] button', wrap).forEach(function (x) { x.classList.toggle('on', x === b); });
    $$('[data-sc-grid] .sc', wrap).forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-c') !== f; });
  });

  function init(root) { marquees(root); whyTabs(root); videoTiles(root); alternate(); }
  window.HW.init = init;
  if (document.readyState !== 'loading') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
